import React from 'react';
import { Loader2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export const ReportEditLoading: React.FC = () => (
  <Card>
    <CardContent className="text-center py-12">
      <div className="flex items-center justify-center gap-2">
        <Loader2 className="w-6 h-6 animate-spin text-gray-600" />
        <p className="text-gray-500">Carregando Report...</p>
      </div>
    </CardContent>
  </Card>
);
